import { render, staticRenderFns } from "./SignatureAlert.vue?vue&type=template&id=19b49370&"
import script from "./SignatureAlert.vue?vue&type=script&lang=js&"
export * from "./SignatureAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports